import { render, staticRenderFns } from "./ManagePrograms.vue?vue&type=template&id=9a35ea52&"
import script from "./ManagePrograms.vue?vue&type=script&lang=js&"
export * from "./ManagePrograms.vue?vue&type=script&lang=js&"
import style0 from "./ManagePrograms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports